import { Box } from '@chakra-ui/react';

import { RefreshIcon, CloseIcon, CheckIcon } from 'Asset/icon';
import { TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';
import { useTranslation } from 'react-i18next';

const RescheduleBadgeStatus = ({ status }) => {
  const { t } = useTranslation('host-reschedule');
  switch (status) {
    case 'Diproses':
      return (
        <Box className={`${styles['badge-status']} ${styles['badge-status--process']}`}>
          <RefreshIcon size={'12px'} color="var(--color-neutral70)" />
          <TextRegular className={styles['badge-status__text']}>{t('request_status.processing')}</TextRegular>
        </Box>
      );
    case 'Ditolak':
      return (
        <Box className={`${styles['badge-status']} ${styles['badge-status--rejected']}`}>
          <CloseIcon size={'12px'} color="var(--color-error60)" />
          <TextRegular className={styles['badge-status__text']}>{t('request_status.rejected')}</TextRegular>
        </Box>
      );
    default:
      return (
        <Box className={`${styles['badge-status']} ${styles['badge-status--approved']}`}>
          <CheckIcon size={'12px'} color="var(--color-success70)" />
          <TextRegular className={styles['badge-status__text']}>{t('request_status.approved')}</TextRegular>
        </Box>
      );
  }
};

export default RescheduleBadgeStatus;
